// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1-TYS","modal":"Modal_modal__1WJir","slide-down":"Modal_slide-down__1BvWv"};